import { FieldValues, UseFormGetValues, UseFormRegister, UseFormSetValue } from 'react-hook-form'
import { useState } from 'react'
import { MEDIATEKA_DOWNLOAD } from '@/constants/urls'
import { IAnswer, IManyOfMany } from '@/models'
import { useWindowSize } from '@/hooks/useWindowSize'
import { Emoji, Input, Text } from '@/components/ui'
import { SelectAnswer } from '../ui'
import { EXPIRED_ANSWER_TITLE } from '@/constants/quiz'
import s from './question-types.module.scss'

interface IManyOfManyQuestionProps {
  question: IManyOfMany
  register: UseFormRegister<FieldValues>
  setValue: UseFormSetValue<FieldValues>
  getValues: UseFormGetValues<FieldValues>
}

const ManyOfManyQuestion = ({ question, register, setValue, getValues }: IManyOfManyQuestionProps) => {
  const { deviceWidth } = useWindowSize()
  const [checkedExcludedAnswer, setCheckedExcludedAnswer] = useState<string | undefined>()

  const uncheckAllFreeFormAnswers = (hookFormKey: string) => {
    if (question?.max_user_free_form_answers) {
      new Array(question?.max_user_free_form_answers)
        .fill('')
        .map((_v: string, i: number) => setValue(`${hookFormKey}${i}`, false))
    }
  }

  return (
    <>
      {question?.answers
        ?.filter((q: IAnswer) => EXPIRED_ANSWER_TITLE !== q.title)
        ?.map((answer: IAnswer) => (
          <SelectAnswer
            key={answer.uuid}
            name={`${question.id}.answer_uuid.${answer.uuid}`}
            register={register}
            value={Boolean(answer.uuid)}
            onChange={(e) => {
              e.preventDefault()
              const keyPrefix = `${question.id}.answer_uuid`
              const key = `${keyPrefix}.${answer.uuid}`
              if (answer.is_excluding_answer) {
                uncheckAllFreeFormAnswers(`${keyPrefix}.FREE_FORM-`)
                setCheckedExcludedAnswer(answer.uuid)
                question.answers.forEach(({ uuid }) => setValue(`${keyPrefix}.${uuid}`, uuid === answer.uuid))
                if (checkedExcludedAnswer === answer.uuid) {
                  setCheckedExcludedAnswer(undefined)
                  setValue(key, false)
                }
              } else {
                // uncheckAllFreeFormAnswers(`${keyPrefix}.FREE_FORM-`)
                if (!checkedExcludedAnswer) {
                  setValue(key, !getValues(key))
                  question.answers.forEach((item: IAnswer) => {
                    if (item.is_excluding_answer) setValue(`${keyPrefix}.${item.uuid}`, false)
                  })
                }
                if (checkedExcludedAnswer) {
                  question.answers.forEach(({ uuid }) => setValue(`${keyPrefix}.${uuid}`, uuid === answer.uuid))
                  setCheckedExcludedAnswer(undefined)
                }
              }
            }}
          >
            {answer?.title && <Text>{answer?.title}</Text>}
            {answer?.image_id && (
              <img
                src={`${MEDIATEKA_DOWNLOAD}/${answer.image_id}`}
                className={s['answer-image']}
                alt='Изображение ответа'
              />
            )}
            {answer?.smile && (
              <Emoji name={answer.smile} size={deviceWidth === 'large' ? 'lg' : 'md'} style={{ marginLeft: 3 }} />
            )}
          </SelectAnswer>
        ))}
      {!!question?.max_user_free_form_answers &&
        new Array(question?.max_user_free_form_answers).fill('').map((_v: string, i: number) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={i} style={{ height: 48 }}>
            <SelectAnswer
              name={`${question.id}.answer_uuid.FREE_FORM-${i}`}
              register={register}
              value={Boolean(`FREE_FORM-${i}`)}
              onChange={(e) => {
                e.preventDefault()
                const keyPrefix = `${question.id}.answer_uuid`
                const key = `${keyPrefix}.FREE_FORM-${i}`
                if (question.free_form_answer_is_excluding) {
                  setCheckedExcludedAnswer(`FREE_FORM-${i}`)
                  question.answers.forEach(({ uuid }) => setValue(`${keyPrefix}.${uuid}`, false))
                  if (getValues(`${question.id}.free_form_answer.${i}`) === '') setValue(key, !getValues(key))
                  else setValue(key, true)
                  setCheckedExcludedAnswer(undefined)
                } else {
                  question?.answers?.forEach(({ uuid }) => {
                    if (question.free_form_answer_is_excluding) setValue(`${keyPrefix}.${uuid}`, false)
                  })
                  if (checkedExcludedAnswer) {
                    question?.answers?.forEach(({ uuid }) => {
                      if (uuid === checkedExcludedAnswer) setValue(`${keyPrefix}.${uuid}`, false)
                    })
                    setCheckedExcludedAnswer(undefined)
                  }
                  setValue(key, !getValues(key))
                }
              }}
            >
              <div />
            </SelectAnswer>
            <Input
              name={`${question.id}.free_form_answer.${i}`}
              register={register}
              className={s['many-of-many-free-form-answer-input']}
              placeholder='Введите свой вариант ответа (Не более 500 символов)'
              fluid
              onMouseDown={() => setValue(`${question.id}.answer_uuid.FREE_FORM-${i}`, true)}
            />
          </div>
        ))}
    </>
  )
}

export default ManyOfManyQuestion
